import React, { ReactNode, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fetch from "unfetch";

import Header from "./header";
import AnnouncementBar from "./announcementBar";
import Footer from "./footer";
import { GlobalStyle, Main } from "@styles/globalStyles";
import { useStore, defaultShopify } from "@state/store";
import Login from "@shopify/login";
import Cart from "@shopify/cart";
import WelcomeModal from "@shared/welcomeModal";
import { useHasMounted, usePinterestTag } from "@util/hooks";
import { Maybe } from "@graphql-types";
import GlobalCssVars from "./globalCssVars";


interface Props {
  children: ReactNode;
  template?: Maybe<string>;
}

function Layout(props: Props) {
  const { children } = props;
  const hasMounted = useHasMounted();

  const {
    visibility: { loginDrawerVisible, cartDrawerVisible },
    closeDrawer,
  } = useStore();
  usePinterestTag();

  useEffect(() => {
    if (!hasMounted) return;
    closeDrawer();
    getCart();

    // Add has-mounted class to html element
    document?.documentElement?.classList?.add('has-mounted');

  }, [hasMounted]);

  return (
    <div>
      <GlobalCssVars />
      <GlobalStyle />
      <WelcomeModal />
      <AnnouncementBar />
      <Header hasScrolled />
      <Main>{children}</Main>
      <ToastContainer position="bottom-right" />
      <Login visible={loginDrawerVisible} />
      <Cart visible={cartDrawerVisible} />
      <Footer />
    </div>
  );
}

export default Layout;

const getCart = async () => {
  const shopify = useStore.getState().shopify;
  if (!shopify.cart?.id) return;
  const res = await fetch(`/api/cart`, {
    method: "POST",
    body: JSON.stringify({
      cartId: shopify?.cart?.id,
    }),
  });
  try {
    const response = await res.json();
    useStore.setState({
      shopify: {
        ...shopify,
        cart: response.cart,
      },
    });
  } catch (err) {
    useStore.setState({
      shopify: {
        ...shopify,
        cart: defaultShopify.cart,
      },
    });
  }
};
